import React from 'react';
import { createRoot } from 'react-dom/client';
import '@fontsource/bebas-neue';
import '@fontsource-variable/manrope';
import '@fontsource-variable/jetbrains-mono';
import './styles.css';
import { App } from './App.js';
import { registerServiceWorker } from './lib/sw.js';

createRoot(document.getElementById('root')!).render(<React.StrictMode><App /></React.StrictMode>);
registerServiceWorker();
